export default {
footer: {
    ageRestriction: "Platform kami hanya untuk pengguna berumur 18 tahun ke atas. Perjudian boleh menyebabkan ketagihan. Sila bermain dengan bertanggungjawab dan hanya untuk hiburan. Untuk maklumat lanjut, lawati halaman Perjudian Bertanggungjawab kami.",
    followUs: "IKUTI KAMI",
    company: "SYARIKAT",
    legal: "UNDANG-UNDANG",
    support: "SOKONGAN",
    gameProviders: "PENYEDIA PERMAINAN",
    copyright: "Copyright © 2019-2026 LOGO. Hak Cipta Terpelihara.",
	documents: "Dokumen",
  }
}
